import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppService } from '../../../../services/app.service';
import { ConfirmComponent } from '../dialog/confirm.component';
import { DossierAlerteDialogComponent } from '../dialog/dossier-alerte-dialog.component';



@Component({
    selector: 'relation-information',
    templateUrl: './relation-information.component.html',
    styleUrls: ['./relation-information.component.scss']
})
export class RelationInformationComponent {

    @Input() dossier: any;
    @Input() relation: any;
    isInformation:boolean = false;
    
    tier: any;
    canAddNewAlerts: boolean = false;
    listAlerts: any;
    newCreatedId: any = null;
    constructor(
        private appService: AppService,
        public dialog: MatDialog,
        private changeDetectorRef: ChangeDetectorRef
    ) {

    }

    ngOnInit(): void {
	   if ( this.relation!=undefined) {
	        console.log("RelationInfomrationComponent init",this.relation);
	        this.isInformation=(this.relation.debutdate || this.relation.findate || this.relation.motif );
		}
    }
    

}
